import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { GlobalVars } from '../../../providers/globalVars';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, AlertController, NavController,IonRouterOutlet } from '@ionic/angular';
import { AuthData } from '../../../providers/auth-data';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.page.html',
  styleUrls: ['./forgot.page.scss'],
})
export class ForgotPage implements OnInit {
  resetPasswordForm:any;
  
  constructor(public authData: AuthData,public fb: FormBuilder,public gv:GlobalVars, public router: Router,
    public navCtrl:NavController,public outlet:IonRouterOutlet
    , public loadingCtrl: LoadingController,public translate: TranslateService, public alertCtrl: AlertController) { 

    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.resetPasswordForm = fb.group({
        email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])]
    })
  }
  ngOnInit() {
  }

  async reset(){
    if (!this.resetPasswordForm.valid){
        console.log("form is invalid = "+ this.resetPasswordForm.value);
    } else {

      let loadingPopup = await this.loadingCtrl.create({
        spinner: 'crescent', 
        message: ''
      })//
      loadingPopup.present();
     
      this.authData.resetPassword(this.resetPasswordForm.value.email)
      .then((user) => {
          var resetlinkconfirmmsg;
          this.translate.get('resetlinkconfirmmsg').subscribe(res=>{
            resetlinkconfirmmsg = res;
          });
          loadingPopup.dismiss();
          this.presentAlert(resetlinkconfirmmsg);
          this.navCtrl.pop();
      }, (error) => {
          loadingPopup.dismiss();
          var errorMessage: string = error.message;
          this.presentAlert(errorMessage);
      });
    }
  }

  async presentAlert(title) {
    var okmsg;
    this.translate.get('Confirm').subscribe(res=>{
      okmsg = res;
    });
    let alert = await this.alertCtrl.create({
      message: title,
      buttons: [okmsg]
    });
    alert.present();
  }

}
